// extracted by mini-css-extract-plugin
module.exports = {"main":"logistics_main__TcZqW","btn":"logistics_btn__2WHmK"};